import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { POST, APIImpl } from '../api';
import { ForgotPasswordRequest } from './forgotpasswordrequest';

export class ForgotPasswordAPI extends APIImpl<ForgotPasswordRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/reset-password
        return "reset-password";
    }
    
    getRequestData()
    {
       return "msisdn="+ this.getRequest().getForgotPasswordRequest().getMsisdn()+"&"+
              "encryptedPassword="+ this.getRequest().getForgotPasswordRequest().getEncryptedPassword()+"&"+
              "clientTxnId="+ this.getRequest().getForgotPasswordRequest().getClientTxnId()+"&"+
              "otp="+ this.getRequest().getForgotPasswordRequest().getOTP()+"&"+
              "securityCounter="+ this.getRequest().getForgotPasswordRequest().getSecurityToken()+"&"+
              "secToc="+ this.getRequest().getForgotPasswordRequest().getSecToc();
        
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/forgotpassword/forgotpasswordapi.tsx